import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import { capitalize } from "common/api";

import RuleModal from "../../Rules/RuleModal";
import { CONST_TREE_RULE } from "../../Rules/constants";
import ConflictsModal from "../../Rules/ConflictsModal";
import ProfMenuItem from "../../Rules/ProfMenuItem";
import { resizeRulesTree } from "../../Rules/utils";
import {
  getRulesAndConflicts,
  fetchRules,
  fetchRulesError,
  parseConflicts,
  parseRules,
  handleTabChange
} from "../../Rules/utils";
import {viewContainer} from "../../Rules/styles";

import SubscriberFlowsTabs from "./Tabs";
import RulesTreeHelpModal from "./Help";
import { PROFS, POLI, VIEW } from "./constants";

const doesNothing = () => {};

const ContextMenu = ({ dpiEnabled, tab }) => {
  const actions = useContext(ActionsContext);

  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li key="menu-open-help">
        <a
          data-loading-effect="pulse"
          data-toggle="cardloading"
          title="Help"
          onClick={() => actions.send("open-help")}
        >
          <i className="material-icons">help_outline</i>
        </a>
      </li>
      <li key="menu-refresh">
        <a
          onClick={() => actions.send("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
      <li className="dropdown hidden-to-operators" key="menu-dropdown">
        <a
          className="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          title="Options"
        >
          <i className="material-icons">more_vert</i>
        </a>
        <ul className="dropdown-menu pull-right">
          <li key="menu-add-rule">
            <a
              id="rulesFlowAddRuleBtn"
              onClick={() => actions.send("open-rule-modal", { type: "Add" })}
            >
              Add Rule...
            </a>
          </li>
          <li key="menu-add-policy">
            <a
              id="rulesFlowAddPoliBtn"
              onClick={() =>
                globalNavigate("viewPolicyFlowEdit", {returnView: "viewRulesFlow", tab})
              }
            >
              Add Policy ...
            </a>
          </li>
          {PROFS.map( profile => (
              <ProfMenuItem
                key={profile.attr}
                {...profile}
                dpiEnabled={dpiEnabled}
                returnView="viewRulesFlow"
              />
            )
          )}
          <li key="menu-show-conflicts">
            <a
              id="rulesFlowShowConflictsBtn"
              onClick={() => actions.send("open-conflict-modal")}
            >
              Show Rule Conflicts...
            </a>
          </li>
        </ul>
      </li>
    </ul>
  );
};

const OPTIONS_PROFILES = [...PROFS, POLI].reduce((acc, value) => {
  const { attr } = value;
  if (attr !== "poli") {
    acc[attr] = [{ label: CONST_TREE_RULE.ANY, value: "any" }];
  } else {
    acc[attr] = [
      { label: CONST_TREE_RULE.ANY, value: "any" },
      { label: "flow-default", value: "flow-default" },
    ];
  }
  return acc;
}, []);

const OPTIONS_SELECTED_INIT = [...PROFS, POLI].reduce((acc, value) => {
  const { attr } = value;
  acc[attr] = "any";
  return acc;
}, {});

const SubscriberFlows = ({ ...params }) => {
  const { dpiEnabled, tab: paramTab } = params;
  const initTab = paramTab || 0;
  const actions = useContext(ActionsContext);
  const [tab, setTab] = useState(Number(initTab));
  const navigate = useNavigate();
  const [rules, setRules] = useState({
    rules: [],
    rulesResp: "",
    conflicts: undefined,
  });

  const doLoad = () => {
    setRules({
      rules: [],
      rulesResp: "",
      conflicts: undefined,
    });
    getRulesAndConflicts("flow", PROFS, POLI)
      .then(([rules, conflicts]) => {
        setRules({
          rules: rules.parsedResponse,
          rulesResp: rules.response,
          conflicts,
        });
      })
      .catch((error) => {
        showModalError("Error: ", error);
      });
  };

  useEffect(() => doLoad() || actions.recv("do-load", doLoad), []);

  const { rules: rulesTree, conflicts, rulesResp } = rules;

  useEffect(() => {
    setTab(Number(params.tab) || 0);
  }, [params.tab]);

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <div className="header block-header">
          <h2>Subscriber Flows Configuration</h2>
          <ContextMenu dpiEnabled={dpiEnabled} tab={tab} />
        </div>
        <div>
          {rules.rules.length > 0 ? (
            <SubscriberFlowsTabs
              rules={rulesTree}
              conflicts={conflicts}
              response={rulesResp}
              tab={tab}
              setTab={(tab)=>handleTabChange(tab, "viewRulesFlow", dpiEnabled, navigate)}
            />
          ) : null}
        </div>
      </div>
      <RuleModal
        rules={rulesTree}
        optionsProfs={OPTIONS_PROFILES}
        initSelection={OPTIONS_SELECTED_INIT}
        view="flow"
        profs={PROFS}
        poli={POLI}
      />
      <RulesTreeHelpModal />
      <ConflictsModal />
    </div>
  );
};

export default SubscriberFlows;
